// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.emulsion_stability */
var EmulsionStability;
(function (EmulsionStability) {
    EmulsionStability["stable"] = "stable";
    EmulsionStability["unstable"] = "unstable";
})(EmulsionStability || (EmulsionStability = {}));
;
export default EmulsionStability;
/** Zod schema for emulsion_stability */
export const emulsionStability = z.nativeEnum(EmulsionStability);
//# sourceMappingURL=EmulsionStability.js.map